export enum TabOptions {
  Organisations = "organisations",
  UserAccounts = "accounts",
  OrganisationDetail = "organisationdetails",
}
